// extracted by mini-css-extract-plugin
export default {"tooltip":"On-z","sharingV2":"Pn-z","sharingIconsV2":"Qn-z","links":"Rn-z","link":"Sn-z","facebookV2":"Tn-z","twitterV2":"Un-z","pinterestV2":"Vn-z"};